import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "src/_metronic/helpers/AssetHelpers";
import Select, { SingleValue } from "react-select";
import { SimpleFormSelectOption } from "../form/SimpleFormSelect";

export interface ITabsData {
    name: string;
    index: number;
}
export interface IDynamicTabs {
    tabs?: Array<{ name: string; index: number }>;
    deletable?: boolean;
    addOptions?: SimpleFormSelectOption[];
    firstElementDeletable?: boolean;
    onSelect?({ name, index }: ITabsData): void;
    seleted?: ITabsData;
    onDelete?(tab: ITabsData, index: number): void;
    onAdd?({ name, index }: ITabsData): void;
}
const DynamicTabs = (props: IDynamicTabs) => {
    const {
        tabs = [{ name: "home", index: 0 }],
        onSelect = () => {},
        seleted,
        addOptions,
        deletable = true,
        firstElementDeletable = true,
        onDelete = () => {},
        onAdd = () => {},
    } = props;

    return (
        <div className="dynamicTabsWrapper">
            <div className="tabsWrapper">
                {tabs.map((tab, index) => (
                    <div
                        key={tab.index}
                        className={`dynamicTabs ${
                            seleted?.index === tab.index ? "dynamicTabs-selected" : ""
                        } `}
                        onClick={() => onSelect({ ...tab })}
                    >
                        {deletable && !(firstElementDeletable && index === 0) && (
                            <SVG
                                width={18}
                                height={18}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    onDelete(tab, index);
                                }}
                                src={toAbsoluteUrl("/media/icons/duotune/arrows/arr011.svg")}
                                className="dynamicTabs-DeleteIcon"
                            />
                        )}
                        {tab.name}
                    </div>
                ))}
            </div>
            <div className="dynamicTabs-select-wrapper">
                {addOptions && (
                    <Select
                        options={addOptions}
                        value={null}
                        styles={{
                            control: (baseStyles) => ({
                                ...baseStyles,
                                fontSize: "1.1rem",
                                fontWeight: "500",
                                lineHeight: "1.5",
                                minHeight: "43.39px",
                                backgroundColor: "var(--kt-input-solid-bg)",
                            }),
                            option: (baseStyles, state) => ({
                                ...baseStyles,
                                backgroundColor: state.isFocused
                                    ? "var(--kt-primary)"
                                    : "var(--kt-input-solid-bg)",
                                fontWeight: "500",
                                lineHeight: "1.5",
                                fontSize: "0.9rem",
                                color: state.isSelected
                                    ? state.isFocused
                                        ? "white"
                                        : "var(--kt-primary)"
                                    : "var(--kt-modal-content-color);",
                            }),
                            singleValue: (baseStyles) => ({
                                ...baseStyles,
                                padding: "3px 5px",
                            }),
                        }}
                        onChange={(
                            newValue: SingleValue<
                                | string
                                | {
                                      label: string;
                                      value: string | number;
                                  }
                            >
                        ) => {
                            if (typeof newValue != "string") {
                                onAdd({
                                    name: newValue?.label || "",
                                    index: parseInt(`${newValue?.value}`, 10),
                                });
                            }
                        }}
                    />
                )}
            </div>
        </div>
    );
};

DynamicTabs.propTypes = {};

export default DynamicTabs;
